import { z } from "zod";
import { HashedIdSchema as IHashedIdSchema } from "@Totum/Main/Domain/schemas";

export const IChoiceSchema = z.object({
    choiceId: IHashedIdSchema,
    choiceText: z.string(),
    orderIndex: z.number(),
    isCorrect: z.boolean().optional(),
});

export const IQuestionSchema = z.object({
    questionnaireId: IHashedIdSchema,
    questionId: IHashedIdSchema,

    choices: z.array(IChoiceSchema),
    isScored: z.boolean().optional(),
    questionType: z.enum(["boolean", "choice"]),
    title: z.string(),
});

export const IQuestionnaireAssociationCollectionSchema = z.object({
    activities: z.array(z.string()),
    activityCategories: z.array(z.string()),
});

export const IQuestionnaireDetailsSchema = z.object({
    questionnaireId: IHashedIdSchema,
    description: z.string(),
    title: z.string(),
    points: z.number().optional(),
    associationCollection: IQuestionnaireAssociationCollectionSchema,
    learningObjectiveDetails: z
        .object({
            description: z.string(),
            learningObjectiveId: IHashedIdSchema,
        })
        .optional(),
    questions: z.array(IQuestionSchema),
    isLocked: z.boolean(),
    isPublished: z.boolean(),
});

export const IQuestionnaireMinimalSchema = z.object({
    questionnaireId: IHashedIdSchema,
    title: z.string(),
    isPublished: z.boolean(),
    isLocked: z.boolean(),
});
